











import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";

@Component({})
export default class HsabTransactionChildRowItem extends Vue {

  @Prop()
  label: string;

  @Prop()
  value: string;
}
